import { Roles } from 'enums';

export const checkIsCustomer = (role?: Roles) => {
  return Roles.COMMUNITY_CUSTOMER === role || Roles.PROPERTY_CUSTOMER === role;
};

export const checkIsAdmin = (role?: Roles) => {
  return Roles.COMPANY_ADMIN === role || Roles.LOCAL_ADMIN === role;
};

export const checkIsSuperAdmin = (role?: Roles) => {
  return Roles.SUPER_ADMIN === role;
};

export const checkIsInspector = (role?: Roles) => {
  return Roles.INSPECTOR === role;
};

export const checkIsManager = (role?: Roles) => {
  return Roles.MANAGER === role;
};
